const Component = {
  "图片 url 不存在": "Ang URL ng larawan ay hindi umiiral",
  "暂不支持下载此类型图片": "Hindi pa suportado ang pag-download ng uri ng larawang ito",
}

export default Component;